
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("kWjpS", function(module, exports) {

$parcel$export(module.exports, "DEVICE", function () { return $f3e8491b2659e311$export$c03ebfdd78bca91c; });
$parcel$export(module.exports, "IS_LOCALHOST", function () { return $f3e8491b2659e311$export$b70801eea72440f5; });
$parcel$export(module.exports, "APP_NAME", function () { return $f3e8491b2659e311$export$5b6c28c7dca07ad7; });
$parcel$export(module.exports, "API_URL", function () { return $f3e8491b2659e311$export$923ea8233b386e99; });
$parcel$export(module.exports, "UPLOAD_URL", function () { return $f3e8491b2659e311$export$5855cb8af78f213c; });
$parcel$export(module.exports, "IMAGE_URL", function () { return $f3e8491b2659e311$export$a1f3871ea0334b37; });
$parcel$export(module.exports, "REVISION", function () { return $f3e8491b2659e311$export$3545e07a80636437; });
$parcel$export(module.exports, "CLOUDFLARE_TURNSTILE_SITE_KEY", function () { return $f3e8491b2659e311$export$8b653f8bcebbadfa; });
$parcel$export(module.exports, "GOOGLE_MAP_KEY", function () { return $f3e8491b2659e311$export$f3ce1a57383674a; });
$parcel$export(module.exports, "PUBLIC_URL", function () { return $f3e8491b2659e311$export$bb1f3a7af481ce64; });
$parcel$export(module.exports, "PUBLIC_ROOT_URL", function () { return $f3e8491b2659e311$export$85f3b95a3de6b791; });
$parcel$export(module.exports, "PUBLIC_DOMAINS", function () { return $f3e8491b2659e311$export$82049ce153d151c4; });
$parcel$export(module.exports, "SENTRY_DSN", function () { return $f3e8491b2659e311$export$6faa4a850bc4d0ce; });
$parcel$export(module.exports, "WEB_PUSH_PUBLIC_KEY", function () { return $f3e8491b2659e311$export$6c13e11e79b68a1a; });
$parcel$export(module.exports, "AMAZON_PARTNER_TAG", function () { return $f3e8491b2659e311$export$a3beca046c38d03e; });
$parcel$export(module.exports, "SOCIAL_INSTAGRAM", function () { return $f3e8491b2659e311$export$a2a95d6318e3a90; });
$parcel$export(module.exports, "SOCIAL_TIKTOK", function () { return $f3e8491b2659e311$export$b03ba9df01fd21f0; });
$parcel$export(module.exports, "SOCIAL_DISCORD", function () { return $f3e8491b2659e311$export$7fbb326a690fb16; });
$parcel$export(module.exports, "SOCIAL_YOUTUBE", function () { return $f3e8491b2659e311$export$9ad6eedf238521c8; });
$parcel$export(module.exports, "SOCIAL_FACEBOOK", function () { return $f3e8491b2659e311$export$520c74000113bf60; });
$parcel$export(module.exports, "SOCIAL_TWITTER_FR", function () { return $f3e8491b2659e311$export$7d855ae79b74f7ba; });
$parcel$export(module.exports, "SOCIAL_TWITTER_EN", function () { return $f3e8491b2659e311$export$a071bd006fb83596; });
$parcel$export(module.exports, "SOCIAL_LINKEDIN", function () { return $f3e8491b2659e311$export$25fe4216bcf6d7e7; });
$parcel$export(module.exports, "SOCIAL_AMAZON", function () { return $f3e8491b2659e311$export$9c8eed2a9f3bdebe; });
$parcel$export(module.exports, "BUILD", function () { return $f3e8491b2659e311$export$455dbfd86f20b704; });
$parcel$export(module.exports, "REFRESH_ERROR_DELAY", function () { return $f3e8491b2659e311$export$18e46e1a3d338ef6; });
$parcel$export(module.exports, "REFRESH_GUEST_DELAY", function () { return $f3e8491b2659e311$export$fb6a413d07f06bfd; });
$parcel$export(module.exports, "REFRESH_USER_DELAY", function () { return $f3e8491b2659e311$export$9d33a56c90bb8291; });
$parcel$export(module.exports, "REFRESH_HOMEPAGE_DELAY", function () { return $f3e8491b2659e311$export$3106e429d2d82819; });
$parcel$export(module.exports, "MESSAGES_BY_PAGE", function () { return $f3e8491b2659e311$export$31c5de43eca1f961; });
$parcel$export(module.exports, "MESSAGES_BY_PAGE_THREADS", function () { return $f3e8491b2659e311$export$543ac66a5cab10ab; });
$parcel$export(module.exports, "ITEMS_BY_PAGE", function () { return $f3e8491b2659e311$export$bce0630e2fcfbc2b; });
$parcel$export(module.exports, "ITEMS_BY_PAGE_SMALL", function () { return $f3e8491b2659e311$export$e9f8c7a69f9651cd; });
$parcel$export(module.exports, "FINGERPRINT_VERSION", function () { return $f3e8491b2659e311$export$2fede4767322709a; });
$parcel$export(module.exports, "FINGERPRINT_CIPHER", function () { return $f3e8491b2659e311$export$858831b250ef127a; });
$parcel$export(module.exports, "FINGERPRINT_SIGNATURE", function () { return $f3e8491b2659e311$export$7e35c91d61e99ae5; });
$parcel$export(module.exports, "LANGUAGES", function () { return $f3e8491b2659e311$export$2092376fd002e13; });
$parcel$export(module.exports, "ALLOWED_CONTENT_LANGUAGES", function () { return $f3e8491b2659e311$export$e30fef19ff6a7de9; });
$parcel$export(module.exports, "ALLOWED_INTERFACE_LANGUAGES", function () { return $f3e8491b2659e311$export$5096dc18b11cf93f; });
$parcel$export(module.exports, "DEFAULT_LANGUAGE", function () { return $f3e8491b2659e311$export$910b680d1eea6990; });
$parcel$export(module.exports, "LS_PREFIX", function () { return $f3e8491b2659e311$export$924ec4fbcda28593; });
$parcel$export(module.exports, "LS_LNG_INTERFACE", function () { return $f3e8491b2659e311$export$9e6a7a3f1783ff21; });
$parcel$export(module.exports, "LS_LNG_CONTENT", function () { return $f3e8491b2659e311$export$3412f14d0eec3108; });
$parcel$export(module.exports, "LS_USER_CACHE", function () { return $f3e8491b2659e311$export$5e8838bff3b17fb; });
$parcel$export(module.exports, "LS_BADGE_CACHE", function () { return $f3e8491b2659e311$export$5f864fcdb6af9068; });
$parcel$export(module.exports, "LS_APRIL_FOOL", function () { return $f3e8491b2659e311$export$eba57fce86e2fda6; });
$parcel$export(module.exports, "LS_DARK_MODE", function () { return $f3e8491b2659e311$export$e0f398de01bb5bdc; });
$parcel$export(module.exports, "PUBLIC_EMAIL", function () { return $f3e8491b2659e311$export$ccd5a224646bd830; });
if (typeof document !== "undefined" && document?.URL?.includes("utm_source=pwa")) sessionStorage.setItem("isPWA", "1");
const $f3e8491b2659e311$export$c03ebfdd78bca91c = typeof document !== "undefined" ? document.URL.includes("ms-appx-web:///") ? "WINDOWS" : !document.URL.includes("http://") && !document.URL.includes("https://") ? "ANDROID" : sessionStorage.getItem("isPWA") ? "PWA" : "WEB" : "SW";
const $f3e8491b2659e311$export$b70801eea72440f5 = typeof window !== "undefined" ? Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) : false;
const $f3e8491b2659e311$export$5b6c28c7dca07ad7 = "reborn-front";
const $f3e8491b2659e311$export$923ea8233b386e99 = "https://api.brickfilms.com/";
const $f3e8491b2659e311$export$5855cb8af78f213c = "https://uploads.brickfilms.com/";
const $f3e8491b2659e311$export$a1f3871ea0334b37 = "https://images.weserv.nl/";
const $f3e8491b2659e311$export$3545e07a80636437 = "e22d562c1dfed376be8cbaf3e8bf0316c700735b";
const $f3e8491b2659e311$export$8b653f8bcebbadfa = "0x4AAAAAAAB2KdPBbnqDgxta";
const $f3e8491b2659e311$export$f3ce1a57383674a = "AIzaSyC48gtHq12YWuBNMNYRy-P-EKadFl6HHK8";
const $f3e8491b2659e311$export$bb1f3a7af481ce64 = "/";
const $f3e8491b2659e311$export$85f3b95a3de6b791 = "https://brickfilms.com/";
const $f3e8491b2659e311$export$82049ce153d151c4 = "brick-a-brack.com,www.brick-a-brack.com,brickfilms.com,www.brickfilms.com,reborn.brickfilms.com".split(",").map((e)=>e.trim());
const $f3e8491b2659e311$export$6faa4a850bc4d0ce = "https://696a72781db14031950441347db30dd9@o145527.ingest.sentry.io/4504244624162816";
const $f3e8491b2659e311$export$6c13e11e79b68a1a = "BMGa95poQh9jKvnKeKPP4GKvB_RD0J_Svor6t4mjzPY46hXeOB21mWlgNOkuPOdRYQcfG2aAyXi-f5XPYEFxcZE";
const $f3e8491b2659e311$export$a3beca046c38d03e = "briabra-21";
const $f3e8491b2659e311$export$a2a95d6318e3a90 = "https://www.instagram.com/BrickfilmsCommunity/";
const $f3e8491b2659e311$export$b03ba9df01fd21f0 = "https://www.tiktok.com/@brickfilmscommunity";
const $f3e8491b2659e311$export$7fbb326a690fb16 = "https://discord.gg/mmU2sVAJUq";
const $f3e8491b2659e311$export$9ad6eedf238521c8 = "https://www.youtube.com/@BrickfilmsCommunity";
const $f3e8491b2659e311$export$520c74000113bf60 = "https://www.facebook.com/BrickfilmsCommunity";
const $f3e8491b2659e311$export$7d855ae79b74f7ba = "https://twitter.com/BrickfilmsFr";
const $f3e8491b2659e311$export$a071bd006fb83596 = "https://twitter.com/BrickfilmsEn";
const $f3e8491b2659e311$export$25fe4216bcf6d7e7 = "https://www.linkedin.com/company/brickfilms-community/";
const $f3e8491b2659e311$export$f1a1b687e3129cfb = "https://www.paypal.me/BRICKABRACK";
const $f3e8491b2659e311$export$9c8eed2a9f3bdebe = `https://www.amazon.fr/?tag=${$f3e8491b2659e311$export$a3beca046c38d03e}`;
const $f3e8491b2659e311$export$322660b545fb0727 = "https://www.tipeee.com/brick-a-brack";
const $f3e8491b2659e311$export$455dbfd86f20b704 = `${$f3e8491b2659e311$export$c03ebfdd78bca91c.toLowerCase()}-${$f3e8491b2659e311$export$3545e07a80636437.substring(0, 7)}`;
const $f3e8491b2659e311$export$18e46e1a3d338ef6 = 10;
const $f3e8491b2659e311$export$fb6a413d07f06bfd = 60;
const $f3e8491b2659e311$export$9d33a56c90bb8291 = 10;
const $f3e8491b2659e311$export$3106e429d2d82819 = 15;
const $f3e8491b2659e311$export$31c5de43eca1f961 = 10;
const $f3e8491b2659e311$export$543ac66a5cab10ab = 15;
const $f3e8491b2659e311$export$bce0630e2fcfbc2b = 24;
const $f3e8491b2659e311$export$e9f8c7a69f9651cd = 10;
const $f3e8491b2659e311$export$2fede4767322709a = 1;
const $f3e8491b2659e311$export$858831b250ef127a = "55499cc7-9c6a-4999-a068-38a80e65b5e8";
const $f3e8491b2659e311$export$7e35c91d61e99ae5 = "a9e48908-a3b0-4551-8051-455ffcd030b4";
const $f3e8491b2659e311$export$2092376fd002e13 = [
    {
        value: "en",
        label: "English",
        tLabel: (t)=>t("English")
    },
    {
        value: "fr",
        label: "Fran\xe7ais",
        tLabel: (t)=>t("Fran\xe7ais")
    },
    {
        value: "de",
        label: "Deutsh",
        tLabel: (t)=>t("Deutsh")
    }
];
const $f3e8491b2659e311$export$e30fef19ff6a7de9 = [
    "en",
    "fr"
]; // API should also handle it or it will cause issues
const $f3e8491b2659e311$export$5096dc18b11cf93f = [
    "en",
    "fr"
];
const $f3e8491b2659e311$export$910b680d1eea6990 = "en";
const $f3e8491b2659e311$export$924ec4fbcda28593 = "bfc_";
const $f3e8491b2659e311$export$9e6a7a3f1783ff21 = `${$f3e8491b2659e311$export$924ec4fbcda28593}currentInterfaceLanguage`;
const $f3e8491b2659e311$export$3412f14d0eec3108 = `${$f3e8491b2659e311$export$924ec4fbcda28593}currentContentLanguages`;
const $f3e8491b2659e311$export$5e8838bff3b17fb = `${$f3e8491b2659e311$export$924ec4fbcda28593}userCache`;
const $f3e8491b2659e311$export$5f864fcdb6af9068 = `${$f3e8491b2659e311$export$924ec4fbcda28593}badgeCache`;
const $f3e8491b2659e311$export$eba57fce86e2fda6 = `${$f3e8491b2659e311$export$924ec4fbcda28593}imnotfun`;
const $f3e8491b2659e311$export$e0f398de01bb5bdc = `${$f3e8491b2659e311$export$924ec4fbcda28593}darkmode`;
const $f3e8491b2659e311$export$ccd5a224646bd830 = "brickabrackv3@gmail.com";

});


//# sourceMappingURL=Homepage.da91303f.js.map
